export type AnalyticsApplicationData = {
  application_category: string;
  application_mode: string;
  application_process: string;
  application_segment: string;
  application_version: number;
  application_id: string;
};

export type AnalyticsEventData = AnalyticsApplicationData & {
  event_category: string;
  event_action: string;
  event_label: string;
  event_value?: string;
};

export type AnalyticsStepData = AnalyticsApplicationData & {
  application_step_number: number;
  application_step_name: string;
  application_step_type: string;
  application_step_required: boolean;
  application_step?: string;
  application_substep_number?: number;
  application_substep_name?: string;
};
export type ApplicationData = AnalyticsEventData | AnalyticsStepData;

export function isAnalyticsStepData(
  data: ApplicationData,
): data is AnalyticsStepData {
  return (
    (typeof data === 'object' &&
      data !== null &&
      'application_step_number' in data) ||
    'application_step_name' in data ||
    'application_step_type' in data ||
    'application_step_required' in data
  );
}
export type QualityData = {
  quality_status: 'n' | 'y';
  quality_impact_critical: 'n' | 'y';
  quality_impact_high: 'n' | 'y';
  quality_impact_medium: 'n' | 'y';
  quality_impact_low: 'n' | 'y';
  quality_label_wrong_value: string[]; //  ['application_mode'],
};

export type EventCollection = {
  event_collection_platform: string;
  event_collection_version: string;
};

export type PianoAnalyticsEventData = {
  page: string;
  page_language: string;
  page_section:
    | 'rbo app'
    | 'rbo desktop'
    | 'secure'
    | 'rbb desktop nl'
    | 'rbb app'
    | 'anoniem';
  page_templatetype: string;
  website_type: 'app' | 'web';
  user_consent: string;
  debug_label?: string;
  debug_abvariant?: string;
  tms_version?: string;
  document_location: string;
  visitor_privacy_consent: boolean;
  visitor_privacy_mode: string;
  device_timestamp_utc: number;
  device_local_hour: number;
  device_hour: number;
  pageview_id: string;
  cookie_creation_date: string;
  device_screen_width: number;
  device_screen_height: number;
  device_display_width: number;
  device_display_height: number;
  previous_url: string;
  page_title_html: string;
  event_url_full: string;
} & ApplicationData &
  UserAgentData &
  Partial<QualityData> &
  EventCollection;

export interface UserAgentData {
  ch_ua: { brand: string; version: string }[];
  ch_ua_arch: string;
  ch_ua_bitness: string;
  ch_ua_full_version_list: { brand: string; version: string }[];
  ch_ua_mobile: boolean;
  ch_ua_model: string;
  ch_ua_platform: string;
  ch_ua_platform_version: string;
  ch_ua_full_version: string;
}

export type EventName = 'application.display' | 'click.action';

export interface HighEntropyValues {
  architecture?: string;
  bitness?: string;
  brands?: { brand: string; version: string }[];
  mobile?: boolean;
  model?: string;
  platform?: string;
  platformVersion?: string;
  uaFullVersion?: string;
  fullVersionList?: { brand: string; version: string }[];
  [key: string]: unknown;
}

export interface NavigatorUAData {
  readonly brands: unknown[];
  readonly mobile: boolean;
  readonly platform: string;

  getHighEntropyValues: (
    highEntropyValues: string[],
  ) => Promise<HighEntropyValues>;
}

export interface NavigatorWithUAData extends Navigator {
  userAgentData: NavigatorUAData;
}
